<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-2 pe-5">
    <a (click)="back()">
      <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
    </a>

    <div class="p-2 flex-grow-1 pl-2">
      <h1 class="text-dark text-center">Elegí el lugar del turno</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()">
      <i class="bi bi-info-circle"></i>
    </div>
  </div>

  @if (helpOpen()) {
    <div class="row m-3 p-3 align-items-center tooltip-pwa tooltip-pwa--open" id="tooltip-pwa" style="display:flex;">
      <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
      <div class="col">{{ helpText() }}</div>
      <div class="col-auto" (click)="openhelp()">
        <i class="bi bi-x-lg" style="font-size: 1.4em;"></i>
      </div>
    </div>
  }

  <div class="row-cols-12 m-2 mb-3 ms-0 me-0">
    <form (ngSubmit)="continuar()" (keydown.enter)="$event.preventDefault()">

      @for (ubicacion of ubicaciones(); track trackByUbiId($index, ubicacion)) {
        <div class="row p-2 px-4 align-items-center notification mb-0">
          <hr class="divisor mt-3 mb-3">

          <div class="col-12 p-0">
            <input
              type="radio"
              class="form-check-input radio-ubicacion"
              [id]="ubicacion.id"
              [value]="ubicacion.id"
              [(ngModel)]="idUbicacionSeleccionada"
              name="ubicacion"
            />

            <label [for]="ubicacion.id" class="label-radio-ubi">
              <div class="col">
                <div class="col-xl">
                  <div class="text-title-item">{{ ubicacion.x_domicilio }}</div>
                  <div class="text-subtitle-item">
                    {{ ubicacion.x_piso_dpto }}, C.P. {{ ubicacion.x_codigo_postal }}
                  </div>
                  @if (ubicacion.nombreProvincia) {
                    <div class="text-subtitle-item">{{ ubicacion.nombreProvincia }}</div>
                  }
                </div>
              </div>
            </label>
          </div>
        </div>
      }

      <hr class="divisor mt-3 mb-0">

      @if (error()) {
        <div class="alert alert-danger mt-4" role="alert">
          <small>{{ error() }}</small>
        </div>
      }

      <div class="d-grid mt-5 mb-3 pb-3">
        <button type="submit" class="btn btn-primary btn-lg mt-0">
          Continuar
        </button>
      </div>
    </form>
  </div>
</div>
